import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const UpdateStoreToSellerShipmentStatusByCargoShipmentCode = (params: any) =>
    request({
        url: ApiURL.Query.UpdateStoreToSellerShipmentStatusByCargoShipmentCode,
        method: RequestType.GET,
        params: params,
    });

const SendShippingListNosRpaMail = (data: any) =>
    request({
        url: ApiURL.Query.SendShippingListNosRpaMail,
        method: RequestType.POST,
        data: data,
    });
const GetShippingListStatusHistory = (params: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetShippingListStatusHistory + '/?shippingListId=' + params.shippingListId,
        method: RequestType.GET,
    });

const UpdateShippingListStatusForReShipping = (data: any) =>
    request({
        url: ApiURL.Query.UpdateShippingListStatusForReShipping,
        method: RequestType.POST,
        data: data,
    });
const CheckRpaStatusByShippingListNumbersRest = (data: any) =>
    request({
        url: ApiURL.Query.CheckRpaStatusByShippingListNumbersRest,
        method: RequestType.POST,
        data: data,
    });
const ShippmentQuery = {
    UpdateStoreToSellerShipmentStatusByCargoShipmentCode,
    SendShippingListNosRpaMail,
    GetShippingListStatusHistory,
    UpdateShippingListStatusForReShipping,
    CheckRpaStatusByShippingListNumbersRest,
};

export default ShippmentQuery;
